import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import { SDKQueryErrorType } from 'types/api';

export const sdkApi = createApi({
  baseQuery: fakeBaseQuery<SDKQueryErrorType>(),
  reducerPath: 'sdkApi',
  endpoints: () => ({}),
});
